import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { editSectionOrderAction } from 'src/reducers/course/action'
import { arrayMove } from '@dnd-kit/sortable'

export const useSectionDragAndDrop = (sections, setSections, courseId) => {
  const [activeId, setActiveId] = useState(null)
  const dispatch = useDispatch()

  const findContainer = id => {
    if (!id) return null
    const [type, stringId] = id.split('__') // Use double underscore as delimiter

    if (type === 'section') {
      const sectionIndex = sections.findIndex(
        section => String(section.id) === stringId,
      )
      if (sectionIndex !== -1) return { type: 'section', index: sectionIndex }
    }

    if (type === 'card') {
      for (let i = 0; i < sections.length; i++) {
        const cardIndex = sections[i].cards.findIndex(
          card => String(card.id) === stringId,
        )
        if (cardIndex !== -1) {
          return { type: 'card', sectionIndex: i, cardIndex }
        }
      }
    }

    return null
  }

  const handleSectionToSectionDrag = (activeIndex, overIndex, prevSections) => {
    const reorderedSections = arrayMove(
      prevSections,
      activeIndex,
      overIndex,
    ).map((section, index) => ({
      ...section,
      order: index,
    }))

    let globalCardOrder = 0
    return reorderedSections.map(section => ({
      ...section,
      cards: section.cards.map(card => ({
        ...card,
        orderOfCard: globalCardOrder++,
      })),
    }))
  }

  const handleCardDrag = (activeContainer, overContainer, prevSections) => {
    const newSections = JSON.parse(JSON.stringify(prevSections))
    const activeSectionIndex = activeContainer.sectionIndex
    const activeCardIndex = activeContainer.cardIndex
    const activeCard = newSections[activeSectionIndex].cards[activeCardIndex]

    newSections[activeSectionIndex].cards.splice(activeCardIndex, 1)

    if (overContainer.type === 'card') {
      const overSectionIndex = overContainer.sectionIndex
      const overCardIndex = overContainer.cardIndex
      newSections[overSectionIndex].cards.splice(overCardIndex, 0, {
        ...activeCard,
        sectionId: newSections[overSectionIndex].id,
      })
    } else if (overContainer.type === 'section') {
      newSections[overContainer.index].cards.push({
        ...activeCard,
        sectionId: newSections[overContainer.index].id,
      })
    }

    return updateCardOrders(newSections, activeContainer, overContainer)
  }

  const updateCardOrders = (sections, activeContainer, overContainer) => {
    let globalCardOrder = 0
    sections.forEach(section => {
      section.cards = section.cards.map(card => ({
        ...card,
        orderOfCard: globalCardOrder++,
      }))
    })
    return sections
  }

  const handleDragStart = event => {
    setActiveId(event.active.id)
  }

  const handleDragOver = event => {
    const { active, over } = event

    if (!over || !active) return

    const activeContainer = findContainer(active.id)
    const overContainer = findContainer(over.id)

    if (!activeContainer || !overContainer) return

    setSections(prevSections => {
      if (
        activeContainer.type === 'section' &&
        overContainer.type === 'section'
      ) {
        return handleSectionToSectionDrag(
          activeContainer.index,
          overContainer.index,
          prevSections,
        )
      }
      /* if (activeContainer.type === 'section' && overContainer.type === 'card') {
        // Handle section-to-card drag (find the section using card's sectionIndex)
        const targetSectionIndex = overContainer.sectionIndex
        return handleSectionToSectionDrag(
          activeContainer.index,
          targetSectionIndex,
          prevSections,
        )
      } */

      if (activeContainer.type === 'card' && overContainer.type === 'card') {
        return handleCardDrag(activeContainer, overContainer, prevSections)
      }

      return prevSections
    })
  }

  const handleDragEnd = () => {
    setActiveId(null)
    dispatch(editSectionOrderAction(courseId, { sections }))
  }

  return {
    activeId,
    handleDragStart,
    handleDragOver,
    handleDragEnd,
  }
}
